









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Person } from '@/models/Person';
import { Slot } from '@/models/CalendarEntries';
import { MeetingCalendarStore } from '@/store/meetingcalendarstate';

@Component
export default class PersonItem extends Vue {
    @Prop() private personData!: Person;
    @Prop() private selectedSlots!: Slot[];

    get classObject(): any {
        return {
            selected: this.isSelected,
            filtered: this.isFiltered
        };
    }
    get isSelected(): boolean {
        return typeof MeetingCalendarStore.getSelectedMeetingPerson !== 'undefined' && MeetingCalendarStore.getSelectedMeetingPerson.id == this.personData.id;
    }
    get isFiltered(): boolean {
        return (
            this.selectedSlots.length > 0 &&
            !this.selectedSlots.some((s: Slot) => {
                return s.person === this.personData.id;
            })
        );
    }
    private handleClick() {
        if (this.isFiltered) {
            return;
        }
        if (typeof MeetingCalendarStore.getSelectedMeetingPerson === 'undefined') {
            MeetingCalendarStore.setSelectedMeetingPerson(this.personData);
        } else if (MeetingCalendarStore.getSelectedMeetingPerson.id === this.personData.id) {
            MeetingCalendarStore.setSelectedMeetingPerson(undefined);
        } else {
            MeetingCalendarStore.setSelectedMeetingPerson(this.personData);
        }
    }
}
